import { Link, NavLink, useLocation } from 'react-router-dom'
import Cookies from 'js-cookie';

import google from '../../5pageAssets/images/buttons/google.png'
import store from '../../5pageAssets/images/buttons/store.png'
import logoDark from '../../5pageAssets/images/logo-dark.png'
import logo from "../../assets/images/logo.png"

const Footer1 = () => {
  const token = Cookies.get("token");
  let location = useLocation()

  return (
    <footer
      // className={`${location.pathname === "/pages/contact-us"
      //   ? "py-16 bg-slate-50"
      //   : "py-16 bg-gradient-to-br from-slate-900 to-slate-800"
      //   }`}
      className='py-16 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100'
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Content */}
        <div className="text-center mb-16">
          <div className="max-w-4xl mx-auto mb-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight text-slate-900 dark:text-white">
              Start offering your users a{' '}
              <span className="text-[#53B1FE]">better experience</span>
            </h2>
            <p className="text-xl text-slate-600 dark:text-slate-300 leading-relaxed max-w-2xl mx-auto">
              Start working with{' '}
              <span className="text-[#53B1FE] font-semibold">Chatinject</span>{' '}
              to showcase your app to thousands of people.
            </p>
          </div>
        </div>

        {/* Footer Links Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 lg:gap-12 mb-12">
          <div className="lg:col-span-1 space-y-6">
            <div className="flex items-center space-x-3">
              <img
                src={logo}
                alt="Chatinject Logo"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Empowering developers to create better user experiences through innovative chat solutions and seamless integrations.
            </p>
          </div>


          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-6">
              Company
            </h3>
            <nav className="flex flex-col space-y-3">
              <NavLink
                to="/pages/about"
                className="text-slate-600 dark:text-slate-300 hover:text-blue-500 dark:hover:text-blue-400 transition-colors duration-200 text-sm font-medium"
              >
                About Us
              </NavLink>
              <NavLink
                to="/pages/pricing"
                className="text-slate-600 dark:text-slate-300 hover:text-blue-500 dark:hover:text-blue-400 transition-colors duration-200 text-sm font-medium"
              >
                Pricing
              </NavLink>
              <NavLink
                to="/"
                className="text-slate-600 dark:text-slate-300 hover:text-blue-500 dark:hover:text-blue-400 transition-colors duration-200 text-sm font-medium"
              >
                Home
              </NavLink>
            </nav>
          </div>

          {/* Resources */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-6">
              Resources
            </h3>
            <nav className="flex flex-col space-y-3">
              <NavLink
                to="/pages/documention/Introduction"
                className="text-slate-600 dark:text-slate-300 hover:text-blue-500 dark:hover:text-blue-400 transition-colors duration-200 text-sm font-medium"
              >
                Documentation
              </NavLink>
              <NavLink
                to={token ? "/dashboards/extrapages/about" : "/auth/sign-in"}
                className="text-slate-600 dark:text-slate-300 hover:text-blue-500 dark:hover:text-blue-400 transition-colors duration-200 text-sm font-medium"
              >
                Support
              </NavLink>
              <NavLink
                to="/pages/privacy-policy"
                className="text-slate-600 dark:text-slate-300 hover:text-blue-500 dark:hover:text-blue-400 transition-colors duration-200 text-sm font-medium"
              >
                Privacy Policy
              </NavLink>
            </nav>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-6">
              Contact
            </h3>
            <div className="space-y-4">
              <div className="text-slate-600 dark:text-slate-300">
                <p className="mb-2 text-sm font-medium">Email us at:</p>
                <a
                  href="mailto:support@chatinject.com"
                  className="text-[#53B1FE] hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200 text-sm font-medium break-all"
                >
                  support@chatinject.com
                </a>
              </div>
              <div className="text-slate-600 dark:text-slate-300">
                <p className="text-sm font-medium">Follow us on social media</p>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        {/* <div className="text-center pt-8 border-t border-slate-200 dark:border-slate-700">
          <p className="text-slate-500 dark:text-slate-400 text-sm">
            © {new Date().getFullYear()} Chatinject. All rights reserved. Crafted by{' '}
            <a
              href="https://settingsinfotech.com/"
              className="text-blue-500 hover:text-blue-600 dark:hover:text-blue-400 font-medium transition-colors duration-200"
              target="_blank"
              rel="noopener noreferrer"
            >
              settingsinfotech
            </a>
          </p>
        </div> */}
        <div className="mt-12 border-t border-neutral-200 dark:border-neutral-700 pt-6 text-center text-sm text-neutral-500 dark:text-neutral-400">
        <p className="inline-block">
          © {new Date().getFullYear()} Chat inject All rights reserved.
          <span className="hidden sm:inline"> &nbsp;|&nbsp; </span>
          <br className="block sm:hidden" />
          <span className="whitespace-nowrap">
            Developed by
            <a
              href="https://settingsinfotech.com/"
              className="text-[#53B1FE] hover:underline ml-1"
              target="_blank"
            >
              Settings Infotech
            </a>
          </span>
        </p>
      </div>

      </div>
    </footer>
  )
}

export default Footer1